import React, { useCallback, useEffect, useState } from "react";
import styles from "../renewal/Renew.module.css";
import Navbar from "../../components/ui/Navbar";
import Footer from "../../components/ui/Footer";
// import { useNavigate } from "react-router";
import Menu from "../../components/ui/Menu";
import DistributorApi from "../../utils/api/DistributorApi";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import modalStyle from "../customers/Customers.module.css";
import copy from "copy-to-clipboard";

function DistributorPinList(props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [exportOption, setExportOption] = useState("");
  const [productData, setProductData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fixedAgent, setFixedAgent] = useState("");
  const [fundAgentModal, setFundAgentModal] = useState(false);
  const [amount, setAmount] = useState(0);
  const [count, setCount] = useState();
  const [pinPlatform, setPinPlatform] = useState("");
  const [productType, setProductType] = useState("CEI");
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [exportContent, setExportContent] = useState(null);
  const [type, setType] = useState("");
  const [price, setPrice] = useState(0);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const token = useSelector((state) => state.userData.loginData.token);

  //   const navigate = useNavigate();

  const [distributors, setDistributors] = useState([]);

  const fetchDistributors = useCallback(async () => {
    try {
      const distributorsRes = await DistributorApi.getAllAgents({
        token,
      });
      setDistributors(distributorsRes.data.data);
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const sellPinRes = await DistributorApi.newSellPin({
        token,
        count: amount,
        fixedagent_email: fixedAgent,
        export_option: exportOption,
        pin_type: productData.platform,
        type: type,
        unit_price: Number(price?.toString().replace(/,/g, "")),
      });
      setIsLoading(false);
      toast.success(sellPinRes?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      fecthPinsCallback();
      setConfirmModalOpen(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  useEffect(() => {
    fetchDistributors();
  }, [fetchDistributors]);

  useEffect(() => {
    const filterProducts = () => {
      const filteredProducts = products.filter((product) =>
        product?.platform?.toLowerCase().includes(productType.toLowerCase())
      );
      setFilteredProducts(filteredProducts);
    };

    if (productType) {
      filterProducts();
    }
  }, [productType, products]);

  useEffect(() => {
    const getPriceList = async () => {
      try {
        setIsLoading(true);
        const priceRes = await DistributorApi.getPrice({
          token,
          pinType: productType,
          type,
        });
        setPrice(priceRes?.data?.data?.price?.toLocaleString() || 0);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    };
    getPriceList();
  }, [token, productType, type]);

  const fecthPinsCallback = useCallback(() => {
    const fetchCartHistory = async () => {
      try {
        setIsLoading(true);
        const productsListRes = await DistributorApi.getNewPinList({
          token,
          status: "ACTIVE",
          platform: productType,
          type: type,
        });
        setProducts(productsListRes.data.data);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    };
    fetchCartHistory();
  }, [token, productType, type]);

  useEffect(() => {
    fecthPinsCallback();
  }, [fecthPinsCallback]);

  const getProductData = (data) => {
    setProductData(data);
  };

  const exportPinModalOpen = (data) => {
    setPinPlatform(data);
    setFundAgentModal(true);
  };

  const exportPin = async () => {
    setIsLoading(true);

    try {
      const response = await DistributorApi.newExportPins({
        token,
        count: parseInt(count),
        pinType: pinPlatform,
        email: fixedAgent,
        type,
      });

      const pinCodes = response.data
        .split("\n")
        .slice(1)
        .map((row) => row.split(",")[1]);
      copy(pinCodes.join("\n"));
      toast.success("Copied to clipboard!", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setExportContent(pinCodes.join("\n"));
      // const blob = new Blob([response.data], { type: "text/csv" });
      // const url = URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = `export_${pinPlatform}_${Date.now()}.csv`;
      // a.setAttribute("allow-downloads", "");
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);
      // URL.revokeObjectURL(url);
      toast.success("Pins exported successfully", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setIsLoading(false);

      setCount("");
    } catch (error) {
      setIsLoading(false);

      toast.error(error.response.data.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to export pins", error);
    }
  };

  const share = () => {
    const isMobile = () =>
      /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);

    if (isMobile() && navigator.share) {
      console.log(pinPlatform);
      navigator
        .share({
          text: exportContent,
        })
        .then(() => {
          setFundAgentModal(false);
          setExportContent(null);

          console.log("Successful share");
        })
        .catch((error) => console.log("Error sharing", error));
    } else {
      console.log("Web Share API not supported.");
    }
  };
  const formatNumber = (value) => {
    const numericValue = value.replace(/,/g, "");
    if (numericValue === "") return "";

    const number = Number(numericValue);
    if (isNaN(number)) return value;

    return number.toLocaleString("en-US");
  };

  const handleChange = (e) => {
    const input = e.target.value.replace(/[^0-9.]/g, "");
    const formattedInput = formatNumber(input);
    setPrice(formattedInput);
  };

  return (
    <div>
      <ToastContainer />
      {fundAgentModal && (
        <div
          className={modalStyle.modal_overlay}
          onClick={() => setFundAgentModal(false)}
        >
          <div
            className={modalStyle.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={modalStyle.modal_title}>Export Pin</h1>
            <div>
              {/* <p className={modalStyle.modal_description}>Fixed Agent</p> */}
              <select
                className={modalStyle.modal_input}
                value={fixedAgent}
                onChange={(e) => setFixedAgent(e.target.value)}
              >
                <option value="">Select Fixed Agent</option>
                {distributors.map((distributor) => (
                  <option key={distributor.id} value={distributor.email}>
                    {distributor.fullname}
                  </option>
                ))}
              </select>

              <input
                className={modalStyle.modal_input}
                type="num"
                onChange={(e) => setCount(e.target.value)}
                value={count}
                placeholder="How many do you want to export"
              />

              {/* <p className={styles.modal_description}>Type</p> */}
              <select
                className={modalStyle.modal_input}
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Select Type</option>
                <option value="Commercial">Commercial</option>
                <option value="PrivateMotor">Private Motor</option>
                <option value="TriCycle">Tri Cycle</option>
                <option value="MotorCycle">Motor Cycle</option>
                <option value="Truck">Truck</option>
              </select>

              {!exportContent ? (
                <button
                  disabled={isLoading}
                  className={modalStyle.modal_button}
                  onClick={() => exportPin()}
                >
                  {isLoading ? `Loading...` : `Export`}
                </button>
              ) : (
                <button
                  className={modalStyle.modal_button2}
                  onClick={() => share()}
                >
                  {isLoading ? `Loading...` : `Share Now`}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {modalOpen && (
        <div
          className={styles.modal_overlay}
          onClick={() => setModalOpen(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={styles.modal_title}>
              {/* {productsDetails?.product_name} */}
            </h1>
            {/* <p className={styles.modal_description}>Pin Type </p>
            <select
              className={styles.modal_input}
              value={pinType}
              onChange={(e) => setPinType(e.target.value)}
            >
              <option value="">Select Pin Type</option>
              <option value="IEI">IEI</option>
              <option value="CEI">CEI</option>
            </select> */}
            <p className={styles.modal_description}>Fixed Agent</p>
            <select
              className={styles.modal_input}
              value={fixedAgent}
              onChange={(e) => setFixedAgent(e.target.value)}
            >
              <option value="">Select Fixed Agent</option>
              {distributors.map((distributor) => (
                <option key={distributor.id} value={distributor.email}>
                  {distributor.fullname}
                </option>
              ))}
            </select>

            <p className={styles.modal_description}>Amount </p>
            <input
              className={styles.modal_input}
              type="num"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
            />

            <p className={styles.modal_description}>Export Option</p>
            <select
              className={styles.modal_input}
              value={exportOption}
              onChange={(e) => setExportOption(e.target.value)}
            >
              <option value="">Select Export Option</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </select>

            <p className={styles.modal_description}>Type</p>
            <select
              className={styles.modal_input}
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="">Select Export Option</option>
              <option value="Commercial">Commercial</option>
              <option value="PrivateMotor">Private Motor</option>
              <option value="TriCycle">Tri Cycle</option>
              <option value="MotorCycle">Motor Cycle</option>
              <option value="Truck">Truck</option>
            </select>

            <p className={styles.modal_description}>Price </p>
            <input
              className={styles.modal_input}
              type="text"
              value={price}
              onChange={handleChange}
            />

            <button
              className={styles.modal_button}
              onClick={() => {
                setConfirmModalOpen(true);
                setModalOpen(false);
              }}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Proceed"}
            </button>
          </div>
        </div>
      )}

      {confirmModalOpen && (
        <div
          className={styles.modal_overlay}
          onClick={() => setConfirmModalOpen(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className={styles.modal_title}>Confirm Details</h2>
            <p className={styles.modal_description}>
              Name: {distributors.find((d) => d.email === fixedAgent)?.fullname}
            </p>

            <p className={styles.modal_description}>Amount: {amount}</p>
            <p className={styles.modal_description}>
              Export Option: {exportOption}
            </p>
            <p className={styles.modal_description}>Type: {type}</p>
            <p className={styles.modal_description}>Price: {price}</p>
            <button
              className={styles.modal_button}
              onClick={(e) => {
                handleSubmit(e);
              }}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Submit"}
            </button>
          </div>
        </div>
      )}

      <div className="menu" onClick={() => props.setShowMenu(false)}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>

      <Navbar title="Pin" setShowMenu={props.setShowMenu} />
      <div>
        <div className={styles.body}>
          <div className={styles.body_bottom}>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <p>Pin Type</p>
              <select
                style={{
                  padding: "10px",
                  borderRadius: "25px",
                  border: "1px solid #ccc",
                  width: "100px",
                  outline: "none",
                  "-webkit-appearance": "none",
                  backgroundColor: "white",
                }}
                className={styles.select_option}
                onChange={(e) => setProductType(e.target.value)}
                value={productType}
              >
                <option value="CEI">CEI</option>
                <option value="IEI">IEI</option>
                <option value="NICON">NICON</option>
              </select>
            </div>
            <div className={styles.cards_wrapper}>
              {filteredProducts
                ?.filter((product) => product.status === "ACTIVE")
                .slice(0, 1)
                ?.map((product, index) => (
                  <div className={styles.card} key={product?.id}>
                    <h1 className={styles.card_title}>{product?.pin}</h1>
                    <p className={styles.card_description}>
                      {product?.platform} -{" "}
                      <span
                        onClick={() => exportPinModalOpen(product?.platform)}
                        style={{
                          fontWeight: "bold",
                          textDecoration: "underline",
                          color: "blue",
                          cursor: "pointer",
                        }}
                      >
                        Export Pin
                      </span>
                    </p>
                    <span className={styles.card_amount}>
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "commercial" &&
                            product.export_option.toLowerCase() === "yes"
                        )?.length
                      }{" "}
                      export,{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "commercial" &&
                            product.export_option.toLowerCase() === "no"
                        )?.length
                      }{" "}
                      non-export Commercial Pin
                      {filteredProducts?.filter(
                        (product) =>
                          product.status === "ACTIVE" &&
                          product.type.toLowerCase() === "commercial" &&
                          product.export_option.toLowerCase() === "yes"
                      )?.length > 1
                        ? "s"
                        : ""}{" "}
                      |{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "privatemotor" &&
                            product.export_option.toLowerCase() === "yes"
                        )?.length
                      }{" "}
                      export,{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "privatemotor" &&
                            product.export_option.toLowerCase() === "no"
                        )?.length
                      }{" "}
                      non-export Private Motor Pin
                      {filteredProducts?.filter(
                        (product) =>
                          product.status === "ACTIVE" &&
                          product.type.toLowerCase() === "privatemotor" &&
                          product.export_option.toLowerCase() === "yes"
                      )?.length > 1
                        ? "s"
                        : ""}{" "}
                      |{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.export_option.toLowerCase() === "yes" &&
                            product.type.toLowerCase() === "tricycle"
                        )?.length
                      }{" "}
                      export,{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "tricycle" &&
                            product.export_option.toLowerCase() === "no"
                        )?.length
                      }{" "}
                      non-export Tri Cycle Pin
                      {filteredProducts?.filter(
                        (product) =>
                          product.status === "ACTIVE" &&
                          product.export_option.toLowerCase() === "yes" &&
                          product.type.toLowerCase() === "tricycle"
                      )?.length > 1
                        ? "s"
                        : ""}{" "}
                      |{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.export_option.toLowerCase() === "yes" &&
                            product.type.toLowerCase() === "motorcycle"
                        )?.length
                      }{" "}
                      export,{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "motorcycle" &&
                            product.export_option.toLowerCase() === "no"
                        )?.length
                      }{" "}
                      non-export Motor Cycle Pin
                      {filteredProducts?.filter(
                        (product) =>
                          product.status === "ACTIVE" &&
                          product.export_option.toLowerCase() === "yes" &&
                          product.type.toLowerCase() === "motorcycle"
                      )?.length > 1
                        ? "s"
                        : ""}{" "}
                      |{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.export_option.toLowerCase() === "yes" &&
                            product.type.toLowerCase() === "truck"
                        )?.length
                      }{" "}
                      export,{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "truck" &&
                            product.export_option.toLowerCase() === "no"
                        )?.length
                      }{" "}
                      non-export Truck Pin
                      {filteredProducts?.filter(
                        (product) =>
                          product.status === "ACTIVE" &&
                          product.export_option.toLowerCase() === "yes" &&
                          product.type.toLowerCase() === "truck"
                      )?.length > 1
                        ? "s"
                        : ""}
                    </span>
                    <span className={styles.card_amount}>
                      {
                        filteredProducts?.filter(
                          (product) => product.status === "EXPORTED"
                        )?.length
                      }{" "}
                      Exported Pin
                      {filteredProducts?.filter(
                        (product) => product.status === "EXPORTED"
                      )?.length > 1
                        ? "s"
                        : ""}
                    </span>

                    <button
                      className={styles.card_button}
                      onClick={() => {
                        setModalOpen(true);
                        getProductData(product);
                      }}
                    >
                      Sell Pin
                    </button>
                  </div>
                ))}

              {isLoading &&
                [...Array(3)].map((_, index) => (
                  <div key={index}>
                    <div className={`${styles.card} ${styles.skeleton}`}></div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default DistributorPinList;
